module.exports = __webpack_public_path__ + "img/CM-MR-CA-Mazda-Established.42cb4430.jpeg";